import { useBackend } from "../../services";
import { useEffect, useState } from "react";
import { StatusCodesHelper } from "../../models/StatusCodesHelper";
import { toast } from "react-toastify";
import { DataStorage } from "../../models/DataStorage";

export const useGetImpacts = <T>(
  setLoading: (loading: boolean) => void,
  dependencies: T[] = []
) => {
  const { get } = useBackend();
  const storage = DataStorage.impactsStorage;
  const [impacts, setImpacts] = useState(storage.getData(false, ""));
  useEffect(() => {
    if (impacts && impacts.length > 0) return;
    setLoading(true);
    get("impacts").then(({ body, status }) => {
      if (StatusCodesHelper.isSuccessful(status)) {
        setImpacts(body);
        storage.setData(body, false, "");
      } else if (!StatusCodesHelper.isSessionExpired(status)) {
        toast.error(body.message);
      }
      setLoading(false);
    });
  }, dependencies);
  return impacts;
};
